<template>
  <div
    class="m--auto"
    :class="theme.type === 'type-e' ? 'p--40px' : themeClasses('boardWidth')"
    v-cloak
  >
    <div class="">
      <div class="view">
        <!-- view 헤드 -->
        <div class="view-head py--24px">

          <span class="font--16px pb--8px inline-block">{{boardName}}</span>
          <h1 class="font--24px pb--24px">
            <span
              class="stamp stamp--sm blue text--white text--middle"
              v-if="row.noticeFlag === 'Y'"
            >공지</span>
            {{row.title}}
          </h1>

          <div class="position--relative">
            <p class="font--14px inline-block mr--12px">by. {{userName}}</p>
            <p class="font--14px inline-block">{{row.updatedAt | dateFmt12}}</p>

            <div :class="viewClass">
              <p class="font--14px inline-block text--middle">{{row.views | number}} 명 읽음</p>
              <div class="inline-block text--middle ml--8p">
                <overflow-menu v-if="isViewMode && hasEditRole">
                  <overflow-menu-item>
                    <a @click="goEdit">
                      수정
                    </a>
                  </overflow-menu-item>
                  <overflow-menu-item>
                    <a @click="remove">
                      삭제
                    </a>
                  </overflow-menu-item>
                </overflow-menu>
              </div>
            </div>

          </div>
        </div><!-- view-head -->
        <div class="">
          <button
            class="py--12px block border-t--1px border--solid border--gray border--lighten-2 w--100% text--left"
            v-for="file in row.files"
            :key="file.fileName"
            @click="$utils.download({url: `/api/boards/${$route.params.boardId}/files/${row.uuid}/${file.fileName}`, query: {}, filename: file.originalName})"
          >
            <i class="material-icons text--gray text--lighten-1 font--18px text--middle">attachment</i>
            <span class="stamp stamp--sm">{{file.originalName}}</span>
          </button>
        </div>
        <!-- view 바디 -->
        <div class="view-body py--40px border-t--1px border--solid border--gray border--lighten-2">
          <div class="ql-snow">
            <div
              class="editor-view ql-editor"
              v-html="readonlyContent"
            >
            </div>
          </div>
          <vue-editor v-show="false" />

        </div>

        <!-- view 바디 -->
        <div
          class="view-body py--40px border-t--1px border--solid border--gray border--lighten-2"
          v-if="answerFlag"
        >
          답변
          <div
            class="editor-view"
            v-html="row.answer"
          >
          </div>
        </div>

        <!-- view 풋터 -->
        <div class="view-foot py--20px">
          <div class="pb--24px">
            <tag :tags="row.tags"></tag>
          </div>

          <div class="position--relative py--10px">
            <button-like
              type="board"
              :row="row"
              @refresh="init"
              v-if="boardMeta.useOptions.recommendFlag === 'Y'"
            ></button-like>
            <!-- <div class="position--absolute right--0px top--0px">
              <button-share></button-share>
            </div> -->
          </div>

          <div class="pt--56px mt--16px border-t--1px border--solid border--gray border--lighten-2">
            <comment-container v-if="boardMeta.useOptions.commentFlag === 'Y'"></comment-container>
          </div>

          <div class="page-btn-group py--32px clearfix">
            <div class="float--left">
              <button
                v-if="user.level >= $utils.getLevel(boardMeta.roles.delete)"
                type="button"
                class="btn btn--xxxl border border--gray border--lighten-2 ml--8px"
                @click="remove"
              >삭제</button>
            </div>

            <div class="float--right">
              <button
                type="button"
                class="btn btn--xxxl border border--gray border--lighten-2 ml--8px"
                @click="goList"
              >목록</button>
              <button
                v-if="isViewMode && hasEditRole"
                type="button"
                class="btn btn--xxxl border border--gray border--lighten-2 ml--8px"
                @click="goEdit"
              >수정</button>
              <button
                v-if="answerFlag && user.level >= $utils.getLevel(boardMeta.roles.answer)"
                type="button"
                class="btn btn--xxxl border border--gray border--lighten-2 ml--8px"
                @click="goAnswer"
              >답변</button>
              <button
                v-if="user.level >= $utils.getLevel(boardMeta.roles.create)"
                type="button"
                class="btn btn--xxxl border border--gray border--lighten-2 ml--8px black text--white"
                @click="goCreate"
              >글쓰기</button>
            </div>
          </div>

          <div
            class="view-list-wrap"
            v-if="boardMeta.useOptions.currentListFlag === 'Y'"
          >
            <board-list
              v-if="boardTheme.list.type === 'list'"
              :rows="board.rows"
              :selectAll="selectAll"
              :goView="goView"
              class1="columns--3 view--text"
              class2="view--thum thum--md thum--left view--text view--list-name"
              :class="boardTheme.list.class || ''"
            ></board-list>
            <board-table
              v-else
              :rows="board.rows"
              :selectAll="selectAll"
              :goView="goView"
              :checkbox="false"
              :currentRow="row.seq || -1"
              :class="boardTheme.list.class || ''"
            ></board-table>

            <div class="text--center pt--30px">
              <pagination :total="board.count" />
            </div>
            <!-- <page-view-list></page-view-list> -->
            <!-- <page-view-list></page-view-list> -->
          </div>
          <!--view-list-wrap-->

        </div>

      </div>
    </div>
    <board-password-dlg
      :isOpen="dlg.isOpen"
      :isError="dlg.isError"
      @closedDlg="onClosedDlg"
    ></board-password-dlg>
  </div>
</template>

<script>
import board from './js/board'
import boardEdit from './js/boardEdit'
import boardMeta from './js/boardMeta'
import theme from '@/component/js/theme'
import { VueEditor } from 'vue2-editor'

export default {
  mixins: [board, boardEdit, boardMeta, theme],
  computed: {
    userName () {
      if (this.row.userId) {
        return `${this.row.userName} (${this.row.userId})`
      }
      return this.row.userName
    },
    readonlyContent () {
      return this.row.content.toString().replace(/(<iframe class="ql-video".*<\/iframe>)/gi, '<div class="embed-container">$1</div>')
    },
    viewClass () {
      if (this.$mq === 'mobile') {
        return ''
      } else {
        return 'position--absolute -top--8px right--0px'
      }
    }
  },
  components: {
    OverflowMenu: () => import('@/component/ui2/menu/OverflowMenu'),
    OverflowMenuItem: () => import('@/component/ui2/menu/OverflowMenuItem'),
    Tag: () => import('@/component/ui2/menu/Tag'),
    ButtonLike: () => import('@/component/ui2/button/ButtonLike'),
    // ButtonShare: () => import('@/component/ui2/button/ButtonShare'),
    CommentContainer: () => import('@/component/ui2/comment/CommentContainer'),
    // PageViewList: () => import('@/component/ui2/page/PageViewList'),
    Pagination: () => import('@/component/ui2/pagination/Pagination'),
    BoardTable: () => import('./component/BoardTable'),
    BoardList: () => import('./component/BoardList'),
    VueEditor
  }
}
</script>
